import { Mail } from "lucide-react";
import Waveform from "../components/Waveform";
import { Reveal, MaskLine } from "../components/Reveal";

const PARTNER_WORDS = ["Artists", "DJs", "Brands", "Venues", "Labels", "Producers", "Athletes", "Festivals"];

const PARTNERS = [
  {
    title: "Artists",
    img: "https://images.unsplash.com/photo-1603910234616-3b5f4a6be2b4?q=80&w=1200&auto=format&fit=crop",
    pos: "center 78%",
    copy: "Host exclusive listening sessions, share your moments through playlists, and build a community that goes beyond the music.",
  },
  {
    title: "DJs",
    img: "https://images.unsplash.com/photo-1777734448565-9655048cf444?q=80&w=1200&auto=format&fit=crop",
    copy: "Gain audience insights before and during events. Track audience analytics, share mixes, and create interactive listening experiences.",
  },
  {
    title: "Brands",
    img: "/brand/brands-streetwear.png",
    copy: "Give your brand a soundtrack. Create memorable experiences through music, visual storytelling, and curated content that resonates with your audience.",
  },
  {
    title: "Venues",
    img: "/brand/venues-lounge.jpg",
    copy: "Build anticipation before events and bring audiences together through music.",
  },
];

function PartnerMarquee() {
  return (
    <div className="partner-marquee" aria-hidden="true" data-testid="partners-marquee">
      <div className="pm-track">
        {[false, true].map((hidden) => (
          <div key={String(hidden)} aria-hidden={hidden || undefined} className="pm-half">
            {[0, 1, 2, 3].map((n) => (
              <ul key={n}>
                {PARTNER_WORDS.map((w) => (
                  <li key={w}>
                    <span>{w}</span>
                    <span className="pm-dot" />
                  </li>
                ))}
              </ul>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Partners() {
  return (
    <>
      <section className="relative overflow-hidden partners-wash" data-testid="partners-hero">
        <div className="glow-blob" style={{ width: 620, height: 620, top: "-30%", right: "-10%" }} aria-hidden="true" />
        <div className="glow-blob glow-azure" style={{ width: 420, height: 420, bottom: "-40%", left: "-12%" }} aria-hidden="true" />
        <div className="relative mx-auto max-w-4xl px-5 sm:px-8 pt-36 sm:pt-44 pb-20 text-center">
          <h1 className="hero-title" data-testid="partners-title">
            <MaskLine delay={0.05}>Partner with</MaskLine>
            <MaskLine delay={0.18}>
              <span className="text-gradient">Tap In</span>
            </MaskLine>
          </h1>
          <p className="body-lg mt-6 text-[1.15rem]" data-testid="partners-sub">
            Join the movement. Build your brand through music experiences.
          </p>
        </div>
        <PartnerMarquee />
      </section>

      <section className="section !pt-14" data-testid="partners-cards">
        <div className="mx-auto max-w-6xl px-5 sm:px-8 grid md:grid-cols-2 gap-6">
          {PARTNERS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.07} testid={`partner-card-${p.title.toLowerCase()}`}>
              <article className="bento-card h-full !p-0">
                <div className="room-cover !h-52 sm:!h-64">
                  <img src={p.img} alt={`${p.title} on Tap In`} loading={i > 1 ? "lazy" : "eager"} style={p.pos ? { objectPosition: p.pos } : undefined} />
                </div>
                <div className="p-6 sm:p-7 flex-1">
                  <h3 className="font-display text-lg font-semibold">{p.title}</h3>
                  <p className="text-[0.92rem] leading-relaxed text-dusk mt-2">{p.copy}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24" data-testid="partners-cta-section">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <Reveal>
            <div className="cta-panel relative overflow-hidden rounded-[2.5rem] border border-grape/40 px-6 py-14 sm:px-14 text-center shadow-glow">
              <div className="glow-blob" style={{ width: 420, height: 420, top: "-45%", left: "28%" }} aria-hidden="true" />
              <div className="relative">
                <h2 className="section-title" data-testid="partners-cta-title">
                  Become a <span className="text-gradient">Partner</span>
                </h2>
                <p className="body-lg mt-4" data-testid="partners-cta-sub">
                  Interested in partnering with Tap In? Let's build something together.
                </p>
                <a
                  href="mailto:contact@tapinsound.app"
                  data-testid="partners-contact-cta"
                  className="apply-pill mt-9"
                >
                  Contact <Mail size={18} />
                </a>
                <div className="mt-10">
                  <Waveform bars={40} className="h-8 opacity-50" testid="partners-cta-waveform" />
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
